import React, { useContext } from "react";

import { Dropdown, Menu } from "semantic-ui-react";
import DownloadDropdownMenuItem from "./DownloadDropdownMenuItem";
import DateRangeMenuItem from "./DateRangeMenuItem";
import { reportContext } from "contexts/ReportContext";

function ReportMenu({ label }) {
	const { types = [], setType } = useContext(reportContext);

	return (
		<Menu
			borderless
			style={{ position: "sticky", top: "0px", zIndex: "99" }}
		>
			<Menu.Item>
				<Dropdown
					as={"h3"}
					floating
					defaultValue={types[0]?.route}
					options={types.map((item) => ({
						key: item.route,
						value: item.route,
						text: item.label,
					}))}
					onChange={(e, b) => setType(b.value)}
				/>
			</Menu.Item>

			<Menu.Menu position="right">
				<Menu.Item>
					<DateRangeMenuItem />
				</Menu.Item>
				<Menu.Item>
					<DownloadDropdownMenuItem />
				</Menu.Item>
			</Menu.Menu>
		</Menu>
	);
}

export default ReportMenu;
